<article [ngClass]="class">
  <h1 *ngIf="heading" >{{heading}}</h1>
  <div>
    <ng-content></ng-content>
  </div>
</article>
